import type { IResponseBase } from '@/interfaces/IResponseBase';
import type { SelectBaseOption } from 'naive-ui/es/select/src/interface';
import { Http } from './http';

export type TemplateVariable = {
	key: string;
	label?: string;
	description?: string;
	required?: boolean;
	defaultValue?: string;
};

function coerceTemplateVariables(payload: string[]): TemplateVariable[] {
	return payload
		.map((v) => {
			return {
				key: v,
				label: v,
				description: undefined,
				required: true,
			};
		})
		.filter(Boolean) as TemplateVariable[];
}

const http = Http.create();

export class DocumentsService {
	static async getAllowedToRenderTemplates() {
		const response = await http.get<IResponseBase<SelectBaseOption[]>>(
			'file/documents-allowed-to-render',
		);
		return response.data.data;
	}

	static async getTemplateVariables(template: string) {
		const safe = encodeURIComponent(template);
		const response = await http.get<IResponseBase<string[]>>(`file/template-variables/${safe}`);
		return coerceTemplateVariables(response.data.data);
	}

	static async renderDocument(template: string, variables: Record<string, string>) {
		const response = await http.post(
			'file/render-document',
			{ documentType: template, variables },
			{
				responseType: 'blob',
				headers: { Accept: 'application/pdf' },
			},
		);

		// Axios returns a Blob when responseType is 'blob' in browser.
		return response.data as Blob;
	}
}

export default DocumentsService;
